import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const RENEWAL_UPLOAD_REQUESTED = 'renewalUpload/requested';
export const RENEWAL_UPLOAD_SUCCEEDED = 'renewalUpload/succeeded';
export const RENEWAL_UPLOAD_FAILED = 'renewalUpload/failed';
export const RENEWAL_STATUS_REQUESTED = 'renewalUpload/statusRequested';
export const RENEWAL_STATUS_SUCCEEDED = 'renewalUpload/statusSucceeded';
export const RENEWAL_STATUS_FAILED = 'renewalUpload/statusFailed';
export const RENEWAL_RESET = 'renewalUpload/reset';

export interface RenewalUploadErrorItem {
  row: number;
  message: string;
}

export interface RenewalUploadState {
  isLoading: boolean;
  error: string | null;
  taskId: string | null;
  status: 'idle' | 'pending' | 'processing' | 'completed' | 'failed' | 'warning';
  progress: number;
  totalRows?: number;
  processedRows?: number;
  successfulRows?: number;
  failedRows?: number;
  errors: RenewalUploadErrorItem[];
  successMessage?: string | null;
}

const initialState: RenewalUploadState = {
  isLoading: false,
  error: null,
  taskId: null,
  status: 'idle',
  progress: 0,
  errors: [],
  successMessage: null
};

const renewalNoticeUploadSlice = createSlice({
  name: 'renewalNoticeUpload',
  initialState,
  reducers: {
    renewalUploadRequested: (
      state,
      _action: PayloadAction<{ file: File; truncate?: boolean }>
    ) => {
      state.isLoading = true;
      state.error = null;
      state.status = 'pending';
      state.progress = 0;
      state.errors = [];
      state.successMessage = null;
    },
    renewalUploadSucceeded: (state, action: PayloadAction<{ task_id: string; message?: string }>) => {
      state.isLoading = false;
      state.taskId = action.payload.task_id;
      state.successMessage = action.payload.message || null;
      state.status = 'processing';
    },
    renewalUploadFailed: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
      state.status = 'failed';
    },
    renewalStatusRequested: (state, _action: PayloadAction<{ taskId: string }>) => {
      state.isLoading = true;
    },
    renewalStatusSucceeded: (state, action: PayloadAction<{ status: RenewalUploadState['status']; progress?: number; total_rows?: number; processed_rows?: number; successful_rows?: number; failed_rows?: number; errors?: RenewalUploadErrorItem[] }>) => {
      state.isLoading = false;
      state.status = action.payload.status;
      state.progress = action.payload.progress ?? state.progress;
      state.totalRows = action.payload.total_rows ?? state.totalRows;
      state.processedRows = action.payload.processed_rows ?? state.processedRows;
      state.successfulRows = action.payload.successful_rows ?? state.successfulRows;
      state.failedRows = action.payload.failed_rows ?? state.failedRows;
      state.errors = action.payload.errors || [];
      if (state.status === 'failed' && state.errors.length === 0) {
        state.error = 'Upload failed';
      }
    },
    renewalStatusFailed: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    renewalReset: (state) => {
      Object.assign(state, initialState);
    }
  }
});

export const {
  renewalUploadRequested,
  renewalUploadSucceeded,
  renewalUploadFailed,
  renewalStatusRequested,
  renewalStatusSucceeded,
  renewalStatusFailed,
  renewalReset
} = renewalNoticeUploadSlice.actions;

export default renewalNoticeUploadSlice.reducer;



